"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNameSpace = void 0;
const models_1 = require("../models");
const createNameSpace = (nameSpace) => {
    return (term) => models_1.NamedNode.getOrCreate(nameSpace + term);
};
exports.createNameSpace = createNameSpace;
//# sourceMappingURL=NameSpace.js.map